/**
 * Calculates the balance for each year
 *
 * @param {number} remainingBalance Remaining balance in pence
 * @param {number} monthlyPayment Monthly payment in pence
 * @param {number} overpaymentAmount Overpayment in pence
 * @param {string} overpaymentInterval Interval - 'monthly' || 'single'
 * @param {number} interestRate Interest rate as a float
 * * OPTIONAL: From date (used in testing)
 * @param {number} [fromDate]
 *
 * @return {array} Array of balances
 *
 */

import getRemainingTerm from './getRemainingTerm';
import getBalanceAtMonth from './getBalanceAtMonth';

const dayjs = require('dayjs');

const getYearToYearBalance = (args) => {
  // Check arguments
  if (!args.remainingBalance && args.remainingBalance !== 0)
    throw new Error('Remaining balance is required');
  if (!args.monthlyPayment && args.monthlyPayment !== 0)
    throw new Error('Monthly payment is required');
  if (!args.interestRate && args.remainingBalance !== 0)
    throw new Error('Interest rate is required');

  const {
    remainingBalance,
    monthlyPayment,
    interestRate,
    overpaymentAmount,
    overpaymentInterval,
  } = args;

  const term = getRemainingTerm({
    remainingBalance,
    monthlyPayment,
    overpaymentAmount: overpaymentAmount || 0,
    overpaymentInterval,
    interestRate,
  });

  const now = dayjs(args.fromDate || new Date());
  const firstYear = dayjs(now).format('YYYY');

  // Set the first year
  const yearToYearBalances = [{ year: firstYear, balance: remainingBalance }];

  /* Set balances to start from beginning of the year */
  const endOfYear = dayjs(now).endOf('year');
  let month = dayjs(endOfYear).diff(now, 'month') + 1;

  // Add 12 months to the term to get the final year
  for (month; month <= term + 12; month += 12) {
    const year = dayjs(now).add(month, 'month').format('YYYY');

    let balance = getBalanceAtMonth({
      month,
      remainingBalance,
      monthlyPayment,
      overpaymentAmount: overpaymentAmount || 0,
      overpaymentInterval,
      interestRate,
    });

    if (balance < 0) balance = 0;

    yearToYearBalances.push({ year, balance });
  }

  return yearToYearBalances;
};

export default getYearToYearBalance;
